<template>
  <div class="l_model_change_faq">
    <div class="container">
      <div class="content">
        <p>
          Androidの一部の機種のサポート終了に伴い、該当機種をご利用のお客様はアプリバージョン3.0.0以上へのアップデートができなくなっております。<br />
          <br />
          サポート対象外となった端末をお使いになっていたお客様で、「アプリ会員ID」と「パスワード」をお控えの場合は、今後機種変更された場合にも「香の川製麺公式アプリ」を引き続きご利用いただけます。
          <br />
          <br />
          利用可能な端末で再度「香の川製麺公式アプリ」をインストールいただき、お控えいただいている「アプリ会員ID」と「パスワード」を入力してお使いください。<br />
          <br />
          有効期限内であれば、アップデート前まで貯められたスタンプやクーポンをご利用いただくことができます。
          <br />
          <br />
        </p>
        <router-link to="/faq/inquiry" @click.native="tapInquiry">
          <div class="l_button__external">
            <UIButton :label="'お問い合わせ'" />
          </div>
        </router-link>
        <p class="caption">
          ※土・日・祝日にいただいたお問合せは翌営業日の受付となります。<br />
          ※メール受信制限等を設定されている場合、返信メールが受け取れない場合がございます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'FAQAndroid',
  components: {
    UIButton
  },
  data: function() {
    return {
      userId: '',
      password: ''
    }
  },
  created() {
    document.title = 'アップデートできない'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedPassword = payload => {
        this.password = payload
        window.receivedPassword = null
      }
      this.actionRequestPassword()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionGetScreenShot',
      'actionRequestPassword'
    ]),
    tapInquiry: function() {
      this.trackEvent(FactoryTrack.createFAQInquiry())
      // const address = 'support@joyfull.support'
      // const subject = 'アプリに関するお問い合わせ'
      // let body = `%0d%0a\
      // アプリ会員ID： ${this.userId}%0d%0a\
      // %0d%0a\
      // 来店した店舗名：%0d%0a\
      // %0d%0a\
      // 来店した日時：%0d%0a\
      // ※おおよその時刻で結構です。%0d%0a\
      // %0d%0a\
      // お問い合わせ内容：%0d%0a\
      // ※「来店してもスタンプがもらえない」「QRコードが案内されない」など%0d%0a\
      // ※機種変更の際は、機種変更された旨と以前使われていたアプリ会員IDをお知らせください。%0d%0a\
      // 【送信前にご確認下さい】%0d%0a\
      // ※土・日・祝日にいただいたお問合せは翌営業日の受付となります。%0d%0a\
      // ※support@joyfull.supportよりご返信させて頂きますので、メール受信制限等を設定されている場合は、左記のアドレスを受信して頂けるよう設定の変更をお願い致します。%0d%0a\
      // `
      // location.href =
      //   'mailto:' + address + '?subject=' + subject + '&body=' + body
    }
  }
}
</script>

<style lang="scss" scoped>
.l_model_change_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;

  p.caption {
    text-align: left;
    margin: 16px -4px;
    font-size: 10px;
    color: rgb(102, 102, 102);
  }
}

.l_model_change_faq h3,
.l_model_change_faq h4 {
  color: #602209;
}

.l_model_change_faq h4 {
  margin: 10px 0px;
}

.l_model_change_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_model_change_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_model_change_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}

.l_model_change_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_model_change_faq span.strong {
  font-weight: bold;

  &.red {
    color: #cc0000;
  }
}

.screenshot {
  text-align: center;

  img {
    width: 75%;
    margin: auto 0;
  }
}

p.account-info {
  margin-top: 1em;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: bold;
}

div.border {
  margin: 0;
  padding: 20px 0;
  border-top: 1px solid gray;
  text-align: left;

  &.bottom {
    border-bottom: 1px solid gray;
  }

  .caption {
    display: block;
    font-size: 12px;
    text-align: left;
  }
}

.mail button {
  padding-left: 20px;
  padding-right: 20px;
}

img {
  max-width: 80%;
  width: 188px;
  display: block;
  border: 1px solid #dedede;
  margin: 0 auto;
}

.strong {
  font-weight: bold;
}

.strong-red {
  font-weight: bold;
  color: #e03535;
}
</style>
